import React from 'react'
import FootBar from './footBar';

const Footer = () => {
    return (
        <div className=''>
            <div className='bg-footer1 p-1 ' >
                <div className='lg:w-11/12 sm:w-11/12 bg-white mx-auto rounded-md p-2'>
                    <div className='lg:w-10/12 mx-auto font-bold text-2xl'>Dirección de Gestion Catastral</div>
                    <div className='sm:text-base text-sm'>
                        <div className='lg:w-10/12 mx-auto font-light py-2'>Dirección: Carrera 5 N° 9 - 74, Piso 3, Alcaldía Municipal de Neiva<br />
                            Atención de lunes a viernes de 8:00am a 11:00am y de 2:00pm a 4:00pm<br />
                            Línea Anticorrupción: +(57)018000919748 o 122<br />
                            Correo Institucional: gestion.catastral@alcaldianeiva.gov.co<br />
                        </div>
                        <div className='mx-auto text-center font-bold p-2 justify-center items-center flex flex-row sm:text-base text-xs'>
                            <a className='px-4' target="_blank" href="https://www.alcaldianeiva.gov.co/Paginas/Politicas-de-Privacidad-y-Condiciones-de-Uso.aspx">Condiciones de uso</a>
                            <a className='px-4' target="_blank" href="https://www.alcaldianeiva.gov.co/Paginas/Politicas-de-Privacidad-y-Condiciones-de-Uso.aspx">Política de privacidad</a>

                        </div>
                    </div>
                </div>
            </div>
            <FootBar />
        </div>

    );
}

export default Footer;